export { Cube as default } from './Cube';
